import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { TopRightOverlay } from 'components/TopRightOverlay/index.js'

const messages = defineMessages({
  mostPopular: {
    id: 'MostPopular.mostPopular',
    defaultMessage: 'Most popular'
  }
})

export function MostPopular () {
  const intl = useIntl()

  return (
    <TopRightOverlay>
      <span>
        {
          formatMessageIntlUtil(intl, messages.mostPopular)
        }
      </span>
    </TopRightOverlay>
  )
}
